import { pxToRem } from '@deltek/specification-client/core/Utilities/unitUtils'
import { LinearProgress, Typography } from '@material-ui/core'
import { Theme, makeStyles } from '@material-ui/core/styles'
import React from 'react'

const useStyles = makeStyles((theme: Theme) => ({
    progressBar: {
        background: (props: ImportProgressProps) =>
            props.progressPercent === 100
                ? '#afb9bf'
                : theme.palette.common.white,
        border: '1px solid #33B55B',
        boxSizing: 'border-box',
        borderRadius: '100px',
        marginLeft: theme.spacing(0.5),
        height: 20,
        width: (props: ImportProgressProps) => (props.isBPImport ? 160 : 120),
        maxWidth: (props: ImportProgressProps) =>
            props.isBPImport ? 160 : 120,
        '& .MuiLinearProgress-bar1Determinate': {
            background: '#33B55B',
            borderRadius: '100px',
        },
        '& .MuiLinearProgress-bar2Determinate': {
            background: '#33B55B',
            borderRadius: '100px',
        },
    },
    labelText: {
        fontSize: pxToRem(12),
        paddingTop: theme.spacing(0.5),
        paddingLeft: theme.spacing(0.5),
        color: (props: ImportProgressProps) =>
            props.isBPImport
                ? theme.palette.common.white
                : theme.palette.common.black,
    },
}))

export interface ImportProgressProps {
    progressPercent: number
    isBPImport?: boolean
}

const ImportProgress: React.FC<ImportProgressProps> = ({
    progressPercent,
    isBPImport,
}) => {
    const classes = useStyles({
        progressPercent: progressPercent,
        isBPImport: isBPImport,
    })
    return (
        <>
            <LinearProgress
                className={classes.progressBar}
                variant="determinate"
                data-testid="importProgress"
                value={progressPercent}
            />

            <Typography
                className={classes.labelText}
                variant="caption"
            >{`${progressPercent}%`}</Typography>
        </>
    )
}
export default ImportProgress
